import React, { FC, ReactNode } from "react";
import cx from "classnames";

interface Props {
  title?: ReactNode;
  description?: ReactNode;
  className?: string;
  "data-testid"?: string;
}

const StatusInfoBlock: FC<React.PropsWithChildren<Props>> = ({
  title,
  description,
  children,
  className,
  "data-testid": testId,
}) => {
  return (
    <div
      className={cx("mt-5 flex justify-between rounded p-2.5", className)}
      data-testid={testId}
    >
      {title && description && (
        <div className="text-s">
          <div className="font-semibold">{title}</div>
          <span className="break-words">{description}</span>
        </div>
      )}
      {children}
    </div>
  );
};

export default StatusInfoBlock;
